import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getBenefits } from '../api/benefit';
import Benefit from './Benefit';
import Loader from './Loader';

interface BenefitListProps {
  title?: string;
  member_level?: string;
  merchant?: any;
  lg_grid?: string;
  sm_grid?: string;
}

const BenefitList: React.FC<BenefitListProps> = ({
  title,
  member_level,
  merchant,
  sm_grid,
  lg_grid,
}) => {
  const [filter, setFilter] = useState({});

  const query = useQuery(['getBenefits', filter], ({ queryKey }) => getBenefits(queryKey[1]));

  useEffect(() => {
    if (member_level) {
      setFilter((prev) => ({ ...prev, member_level }));
    }

    if (merchant) {
      setFilter((prev) => ({ ...prev, merchant }));
    }
  }, []);

  return (
    <div className="ceas-mb-5 ceas-pb-5">
      {title && <h3 className="ceas-text-xl ceas-mb-3">{title}</h3>}
      <div
        className={`ceas-grid ceas-grid-cols-1 ceas-gap-4 sm:ceas-grid-cols-${sm_grid} lg:ceas-grid-cols-${lg_grid}`}
      >
        {query.isLoading ? (
          <Loader />
        ) : query.data?.length > 0 ? (
          query.data.map((benefit: any, key: number) => <Benefit key={key} benefit={benefit} />)
        ) : (
          <p>There is no benefit</p>
        )}
      </div>
    </div>
  );
};

BenefitList.defaultProps = {
  lg_grid: '3',
  sm_grid: '2',
};

export default BenefitList;
